import { useContext, useEffect, useState } from 'react'
import DynamicDownloadBtnSection from '../../components/DynamicDownloadBtnSection/DynamicDownloadBtnSection';
import "../../IQAC/Academic Audit Report Template/AcademicAuditReportTemplate.scss"
import { AppContext } from '../../context/AppContext';
import axios from 'axios';
import { toast } from 'react-toastify';
const AcademicAuditReportTemplate = () => {

  const { backendUrl } = useContext(AppContext);
  const [academicAuditReports, setAcademicAuditReports] = useState([]);
  let errorShown = false;

  async function fetchAllAcademicAuditReports() {
    try {
      const { data } = await axios.get(`${backendUrl}/api/auth/getAllAcademicAuditReports`);
      if (data.success) {
        setAcademicAuditReports(data || []);
      }
      errorShown = false;
    } catch (error) {
      if (errorShown) return;
      errorShown = true;
      if (error.response && error.response.status === 503) {
        toast.error("⚠️ The service is currently under maintenance. Please try again later.");
      }
      else if (!navigator.onLine) {
        toast.error("🚫 No internet connection. Please check your network.");
      }

      else if (error.request && !error.response) {
        toast.error("⚠️ Network issue or server is unreachable. Try again later.")
      }
      else {
        console.error("Unexpected error:", error);
        toast.error("Something went wrong.");
      }
    }
  }

  useEffect(() => {
    fetchAllAcademicAuditReports();
  }, []);

  const content = academicAuditReports?.reports
    ?.filter(item => item.isActive)
    .map(item => ({
      filename: item.filename,
      data: item.data,
      contentType: item.contentType,
    })) || [];


  return (
    <section className="auditMainContainer">
      <header className="auditHeader">
        <h2>Academic Audit Report</h2>
      </header>
      <DynamicDownloadBtnSection
        items={content} yearFontSize={1.25}
      />
    </section>
  )
};

export default AcademicAuditReportTemplate;
